var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkOff = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_276_38661",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_276_38661)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.8334 10.9667L11.8334 9.93337C12.2778 9.81114 12.6389 9.57503 12.9167 9.22503C13.1945 8.87503 13.3334 8.4667 13.3334 8.00003C13.3334 7.44448 13.1389 6.97226 12.75 6.58337C12.3611 6.19448 11.8889 6.00003 11.3334 6.00003H8.66668V4.6667H11.3334C12.2556 4.6667 13.0417 4.9917 13.6917 5.6417C14.3417 6.2917 14.6667 7.07781 14.6667 8.00003C14.6667 8.63337 14.5028 9.2167 14.175 9.75003C13.8472 10.2834 13.4 10.6889 12.8334 10.9667ZM10.5667 8.6667L9.23335 7.33337H10.6667V8.6667H10.5667ZM13.2 15.0667L0.93335 2.80003L1.86668 1.8667L14.1334 14.1334L13.2 15.0667ZM7.33335 11.3334H4.66668C3.74446 11.3334 2.95835 11.0084 2.30835 10.3584C1.65835 9.70837 1.33335 8.92226 1.33335 8.00003C1.33335 7.23337 1.56668 6.55003 2.03335 5.95003C2.50002 5.35003 3.10002 4.95559 3.83335 4.7667L5.06668 6.00003H4.66668C4.11113 6.00003 3.63891 6.19448 3.25002 6.58337C2.86113 6.97226 2.66668 7.44448 2.66668 8.00003C2.66668 8.55559 2.86113 9.02781 3.25002 9.4167C3.63891 9.80559 4.11113 10 4.66668 10H7.33335V11.3334ZM5.33335 8.6667V7.33337H6.41668L7.73335 8.6667H5.33335Z",
  fill: "#bdbdbd"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/link_off.4c4f7f0424f7802fb6faad8cd9cffbe1.svg";